module.exports = __webpack_public_path__ + "img/Mobile-1980.b53459c2.jpg";